import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import "@/gen/hover.css";
import HomePage from "@/pages/HomePage";
import ModelPage from "@/pages/ModelPage";
import FounderPage from "@/pages/FounderPage";
import FieldPage from "@/pages/FieldPage";
import PartnerPage from "@/pages/PartnerPage";
import WhyWeExistPage from "@/pages/WhyWeExistPage";
import ThesisPage from "@/pages/ThesisPage";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(location.hash.slice(1));
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/why-we-exist" element={<WhyWeExistPage />} />
        <Route path="/the-thesis" element={<ThesisPage />} />
        <Route path="/the-model" element={<ModelPage />} />
        <Route path="/the-field" element={<FieldPage />} />
        <Route path="/the-founder" element={<FounderPage />} />
        <Route path="/partner" element={<PartnerPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#13161C", border: "1px solid #23262D", color: "#F2F4F6", fontFamily: "'IBM Plex Sans',sans-serif" } }} />
    </BrowserRouter>
  );
}
